var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-menu-container",
      attrs: { id: "door-sidebar-menu" }
    },
    [
      _c("div", { staticClass: "sidebar-main-label" }, [
        _vm._v("Коррекция перекрытия")
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-step-two-img-container" }, [
        _c("img", {
          staticClass: "sidebar-step-two-img",
          attrs: { src: _vm.urlForStatic("/img/fix_overlap_tip.png") }
        })
      ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-step-two-img-container" }, [
        _c("img", {
          staticClass: "sidebar-step-two-img",
          attrs: { src: _vm.urlForStatic("/img/fix_overlap_tip_2.png") }
        })
      ]),
      _vm._v(" "),
      _vm._m(2)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-text-area" }, [
      _vm._v("В случае, если на вашей фотографии присутствуют посторонние "),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("объекты на переднем плане")
      ]),
      _vm._v(
        ", Вы можете воспользоваться функцией коррекции перекрытия, позволяющей "
      ),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("скрыть участки плоскостей")
      ]),
      _vm._v(" проекта.")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-text-area" }, [
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("Ограничьте объект")
      ]),
      _vm._v(
        " переднего плана контуром, если он заграждает собой здание, расставляя поочерёдно точки по его периметру, как показано на рисунке ниже."
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-text-area" }, [
      _vm._v(
        "После того, как периметр фигуры, обрамляющей объект на фото, будет замкнут, нажмите кнопку "
      ),
      _c("span", { staticClass: "red-text bold-text" }, [_vm._v('"Готово"')]),
      _vm._v(
        ". При необходимости, точки фигуры можно перемещать после расстановки."
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }